import React, { useEffect, useState } from "react";

interface QuizModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AI_API_URL = process.env.REACT_APP_AI_API_URL;

export const QuizModal: React.FC<QuizModalProps> = ({ isOpen, onClose }) => {
  const [selectedDays, setSelectedDays] = useState(7);
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [availableChannels, setAvailableChannels] = useState<{ hls_url: string; name: string }[]>([]);
  const [selectedChannelHls, setSelectedChannelHls] = useState<string>("all");
  const [selectedChannel, setSelectedChannel] = useState("all");

  // Dummy data structure matching backend
  const DUMMY_QUIZ_DATA = {
    all: {
      1: { 
        total_answered: 45, 
        total_shown: 89,
        per_day_answered: [["2024-01-20", 45]],
        top_quizzes: [
          {
            quiz_id: "quiz_001",
            answers: 23,
            question: "What is the current interest rate set by the Federal Reserve?"
          },
          {
            quiz_id: "quiz_002", 
            answers: 18,
            question: "Which company reported the highest quarterly earnings this month?"
          }
        ]
      },
      7: { 
        total_answered: 312, 
        total_shown: 678,
        per_day_answered: [
          ["2024-01-14", 38],
          ["2024-01-15", 52],
          ["2024-01-16", 41],
          ["2024-01-17", 67],
          ["2024-01-18", 29],
          ["2024-01-19", 40],
          ["2024-01-20", 45]
        ],
        top_quizzes: [
          {
            quiz_id: "quiz_001",
            answers: 89,
            question: "What is the current interest rate set by the Federal Reserve?"
          },
          {
            quiz_id: "quiz_003",
            answers: 76,
            question: "Which sector showed the most growth in the latest market analysis?"
          }
        ]
      },
      14: { 
        total_answered: 623, 
        total_shown: 1345,
        per_day_answered: [
          ["2024-01-07", 42], ["2024-01-08", 48], ["2024-01-09", 55], ["2024-01-10", 61], 
          ["2024-01-11", 34], ["2024-01-12", 47], ["2024-01-13", 58], ["2024-01-14", 38],
          ["2024-01-15", 52], ["2024-01-16", 41], ["2024-01-17", 67], ["2024-01-18", 29],
          ["2024-01-19", 40], ["2024-01-20", 45]
        ],
        top_quizzes: [
          {
            quiz_id: "quiz_001",
            answers: 134,
            question: "What is the current interest rate set by the Federal Reserve?"
          },
          {
            quiz_id: "quiz_004",
            answers: 112,
            question: "What was the percentage change in GDP for the last quarter?"
          }
        ]
      },
      30: { 
        total_answered: 1289, 
        total_shown: 2876,
        per_day_answered: [
          ["2024-01-01", 41], ["2024-01-02", 46], ["2024-01-03", 38], ["2024-01-04", 59],
          ["2024-01-05", 31], ["2024-01-06", 48], ["2024-01-07", 42], ["2024-01-08", 48],
          ["2024-01-09", 55], ["2024-01-10", 61], ["2024-01-11", 34], ["2024-01-12", 47],
          ["2024-01-13", 58], ["2024-01-14", 38], ["2024-01-15", 52], ["2024-01-16", 41],
          ["2024-01-17", 67], ["2024-01-18", 29], ["2024-01-19", 40], ["2024-01-20", 45],
          ["2024-01-21", 43], ["2024-01-22", 39], ["2024-01-23", 56], ["2024-01-24", 64],
          ["2024-01-25", 33], ["2024-01-26", 49], ["2024-01-27", 44], ["2024-01-28", 51],
          ["2024-01-29", 37], ["2024-01-30", 53]
        ],
        top_quizzes: [
          {
            quiz_id: "quiz_001",
            answers: 267,
            question: "What is the current interest rate set by the Federal Reserve?"
          },
          {
            quiz_id: "quiz_005",
            answers: 189,
            question: "Which cryptocurrency showed the highest volatility this month?"
          }
        ]
      }
    },
    bloombergtvplus: {
      1: { 
        total_answered: 18, 
        total_shown: 34,
        per_day_answered: [["2024-01-20", 18]],
        top_quizzes: [
          {
            quiz_id: "quiz_bloomberg_001",
            answers: 12,
            question: "What was Tesla's stock performance in the last trading session?"
          },
          {
            quiz_id: "quiz_bloomberg_002",
            answers: 6,
            question: "Which commodities are showing bullish trends this week?"
          }
        ]
      },
      7: { 
        total_answered: 124, 
        total_shown: 267,
        per_day_answered: [
          ["2024-01-14", 15],
          ["2024-01-15", 22],
          ["2024-01-16", 17],
          ["2024-01-17", 28],
          ["2024-01-18", 11],
          ["2024-01-19", 13],
          ["2024-01-20", 18]
        ],
        top_quizzes: [
          {
            quiz_id: "quiz_bloomberg_001",
            answers: 43,
            question: "What was Tesla's stock performance in the last trading session?"
          },
          {
            quiz_id: "quiz_bloomberg_003",
            answers: 31,
            question: "What are the key indicators for next month's inflation report?"
          }
        ]
      },
      14: { 
        total_answered: 267, 
        total_shown: 589,
        per_day_answered: [
          ["2024-01-07", 18], ["2024-01-08", 21], ["2024-01-09", 24], ["2024-01-10", 29], 
          ["2024-01-11", 13], ["2024-01-12", 19], ["2024-01-13", 25], ["2024-01-14", 15],
          ["2024-01-15", 22], ["2024-01-16", 17], ["2024-01-17", 28], ["2024-01-18", 11],
          ["2024-01-19", 13], ["2024-01-20", 18]
        ],
        top_quizzes: [
          {
            quiz_id: "quiz_bloomberg_001",
            answers: 78,
            question: "What was Tesla's stock performance in the last trading session?"
          },
          {
            quiz_id: "quiz_bloomberg_004",
            answers: 56,
            question: "How did the latest jobs report affect market sentiment?"
          }
        ]
      },
      30: { 
        total_answered: 534, 
        total_shown: 1203,
        per_day_answered: [
          ["2024-01-01", 16], ["2024-01-02", 19], ["2024-01-03", 14], ["2024-01-04", 25],
          ["2024-01-05", 12], ["2024-01-06", 20], ["2024-01-07", 18], ["2024-01-08", 21],
          ["2024-01-09", 24], ["2024-01-10", 29], ["2024-01-11", 13], ["2024-01-12", 19],
          ["2024-01-13", 25], ["2024-01-14", 15], ["2024-01-15", 22], ["2024-01-16", 17],
          ["2024-01-17", 28], ["2024-01-18", 11], ["2024-01-19", 13], ["2024-01-20", 18],
          ["2024-01-21", 17], ["2024-01-22", 15], ["2024-01-23", 23], ["2024-01-24", 27],
          ["2024-01-25", 12], ["2024-01-26", 20], ["2024-01-27", 18], ["2024-01-28", 21],
          ["2024-01-29", 14], ["2024-01-30", 22]
        ],
        top_quizzes: [
          {
            quiz_id: "quiz_bloomberg_001",
            answers: 156,
            question: "What was Tesla's stock performance in the last trading session?"
          },
          {
            quiz_id: "quiz_bloomberg_005",
            answers: 89,
            question: "What impact did the latest Fed announcement have on bond yields?"
          }
        ]
      }
    }
  };

  const [hoveredBar, setHoveredBar] = useState<{index: number, count: number, date: string} | null>(null);

//   useEffect(() => {
//     if (isOpen) {
//       setLoading(true);
//       setTimeout(() => {
//         const channelData = DUMMY_QUIZ_DATA[selectedChannel as keyof typeof DUMMY_QUIZ_DATA];
//         setData(channelData[selectedDays as keyof typeof channelData]);
//         setLoading(false);
//       }, 800);
//     }
//   }, [isOpen, selectedDays, selectedChannel]);


    useEffect(() => {
    const controller = new AbortController();
    const loadChannels = async () => {
        try {
        const res = await fetch(`${AI_API_URL}/active-channels`, { signal: controller.signal });
        if (!res.ok) throw new Error("Failed to load channels");
        const json = await res.json();
        setAvailableChannels(json.channels || []);
        } catch (e) {
        if ((e as any).name !== "AbortError") console.error("Error loading channels", e);
        }
    };
    loadChannels();
    return () => controller.abort();
    }, []);


    useEffect(() => {
    if (!isOpen) return () => {};

    const controller = new AbortController();
    setLoading(true);

    const channelParam = selectedChannel === "all" ? "all" : encodeURIComponent(selectedChannel);
    fetch(`${AI_API_URL}/fetch-quiz-stats?days=${selectedDays}&channel=${channelParam}`, {
    signal: controller.signal,
    })
        .then((r) => {
        if (!r.ok) throw new Error("Quiz stats fetch failed");
        return r.json();
        })
        .then((json) => {
        setData(json);
        })
        .catch((err) => {
        if (err.name !== "AbortError") console.error(err);
        })
        .finally(() => setLoading(false));

    return () => controller.abort();
    },  [isOpen, selectedDays, selectedChannel]);


  const maxValue = data ? Math.max(...data.per_day_answered.map((item: any) => item[1])) : 0;
  const selectedChannelName =
    selectedChannel === "all" ? "All Channels" : selectedChannel;

  if (!isOpen) return null;

  return (
    <div
      role="presentation"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(4px)",
        animation: isOpen ? "fadeIn 0.3s ease-out" : "fadeOut 0.3s ease-out",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          onClose();
        }
      }}
      tabIndex={-1}
    >
      <div
        role="dialog"
        aria-modal="true"
        style={{
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(20px)",
          borderRadius: "20px",
          padding: "32px",
          width: "90%",
          maxWidth: "900px",
          maxHeight: "90vh",
          overflowY: "auto",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
          animation: isOpen ? "zoomIn 0.4s cubic-bezier(0.4, 0, 0.2, 1)" : "",
        }}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "32px" }}>
          <div>
            <h2 style={{ color: "#ffffff", fontSize: "24px", fontWeight: "700", margin: 0 }}>
              Quiz Analytics
            </h2>
            <p style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px", margin: "4px 0 0 0" }}>
              Interactive quiz engagement and performance metrics
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              color: "#ffffff",
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            ✕
          </button>
        </div>

        {/* Controls */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
          {/* Time Period Selector */}
          <div>
            <p style={{ margin: 0, marginBottom: 8, color: "rgba(255, 255, 255, 0.8)", fontSize: 14, fontWeight: 500 }}>
              Time Period
            </p>
            <select
              id="quiz-period"
              aria-label="Time period"
              value={selectedDays}
              onChange={(e) => setSelectedDays(Number(e.target.value))}
              style={{
                display: "block",
                width: "100%",
                background: "rgba(255,255,255,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: 8,
                color: "#ffffff",
                padding: "8px 12px",
                fontSize: 14,
                outline: "none",
              }}
            >
              <option value={1} style={{ background: "#1f2937", color: "#ffffff" }}>Last 24 hours</option>
              <option value={7} style={{ background: "#1f2937", color: "#ffffff" }}>Last 7 days</option>
              <option value={14} style={{ background: "#1f2937", color: "#ffffff" }}>Last 14 days</option>
              <option value={30} style={{ background: "#1f2937", color: "#ffffff" }}>Last 30 days</option>
            </select>
          </div>

          {/* Channel Selector */}
          <div>
            <p style={{ margin: 0, marginBottom: 8, color: "rgba(255, 255, 255, 0.8)", fontSize: 14, fontWeight: 500 }}>
              Channel
            </p>
                <select
                id="quiz-channel"
                aria-label="Channel"
                value={selectedChannel}
                onChange={(e) => setSelectedChannel(e.target.value)}
                style={{
                    display: "block",
                    width: "100%",
                    background: "rgba(255,255,255,0.1)",
                    border: "1px solid rgba(255,255,255,0.2)",
                    borderRadius: 8,
                    color: "#ffffff",
                    padding: "8px 12px",
                    fontSize: 14,
                    outline: "none",
                }}
                >
                <option value="all" style={{ background: "#1f2937", color: "#ffffff" }}>
                    All Channels
                </option>
                {availableChannels.map((ch) => (
                    <option
                    key={ch.hls_url}
                    value={ch.name}
                    style={{ background: "#1f2937", color: "#ffffff" }}
                    >
                    {ch.name}
                    </option>
                ))}
                </select>
          </div>
        </div>

        {/* Chart */}
        <div style={{ marginBottom: "32px" }}>
        <h3>Daily Quiz Answers {selectedChannel !== "all" && `- ${selectedChannelName}`}</h3>
          <div
            style={{
              background: "rgba(255, 255, 255, 0.05)",
              borderRadius: "12px",
              padding: "24px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              height: "300px",
              display: "flex",
              position: "relative",
            }}
          >
            {loading ? (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", color: "rgba(255, 255, 255, 0.7)" }}>
                Loading chart...
              </div>
            ) : (
              <>
                {/* Y-Axis */}
                <div
                  style={{
                    width: "50px",
                    height: "240px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                    paddingRight: "12px",
                    marginRight: "16px",
                    borderRight: "1px solid rgba(255, 255, 255, 0.1)",
                  }}
                >
                  {[...Array(6)].map((_, i) => {
                    const value = Math.round((maxValue * (5 - i)) / 5);
                    return (
                      <div
                        key={i}
                        style={{
                          color: "rgba(255, 255, 255, 0.6)",
                          fontSize: "11px",
                          fontWeight: "500",
                          textAlign: "right",
                          lineHeight: "1",
                        }}
                      >
                        {value > 0 ? value : 0}
                      </div>
                    );
                  })}
                </div>

                {/* Chart Area */}
                <div
                  style={{
                    flex: 1,
                    height: "240px",
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "space-around",
                    gap: "4px",
                    position: "relative",
                  }}
                >
                  {/* Horizontal grid lines */}
                  {[...Array(6)].map((_, i) => (
                    <div
                      key={i}
                      style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: `${(i * 240) / 5}px`,
                        height: "1px",
                        background: "rgba(255, 255, 255, 0.05)",
                        pointerEvents: "none",
                      }}
                    />
                  ))}

                  {/* Bars */}
                {data?.per_day_answered.map((item: any, index: number) => {
                const [date, count] = item;
                const height = (count / maxValue) * 240;

                return (
                    <div
                    key={date}
                    style={{
                        position: "relative",
                        flex: 1,
                        height: "100%",
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                    }}
                    >
                    <div
                        style={{
                        height: `${height}px`,
                        width: "100%",
                        maxWidth: 40,
                        background: "linear-gradient(to top, #f59e0b, #fbbf24)",
                        borderRadius: "4px 4px 0 0",
                        boxShadow: "0 4px 12px rgba(245,158,11,0.3)",
                        animation: `barGrowUp 1s ease-out ${index * 0.1}s both`,
                        cursor: "pointer",
                        }}
                        onMouseEnter={() => setHoveredBar({ index, count, date })}
                        onMouseLeave={() => setHoveredBar(null)}
                    />

                    {hoveredBar?.index === index && (
                        <div
                        style={{
                            position: "absolute",
                            bottom: `${height + 10}px`,
                            left: "50%",
                            transform: "translateX(-50%)",
                            background: "rgba(0,0,0,.8)",
                            color: "#fbbf24",
                            padding: "4px 8px",
                            borderRadius: 4,
                            fontSize: 12,
                            fontWeight: 600,
                            pointerEvents: "none",
                        }}
                        >
                        {count}
                        </div>
                    )}

                    <div
                        style={{
                        position: "absolute",
                        bottom: -18,
                        left: "50%",
                        transform: "translateX(-50%)",
                        color: "rgba(255,255,255,.6)",
                        fontSize: 10,
                        lineHeight: 1.2,
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        }}
                    >
                        {new Date(date).toLocaleDateString([], { month: "short", day: "numeric" })}
                    </div>
                    </div>
                );
                })}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Top Quizzes Section */}
        <div style={{ marginBottom: "32px" }}>
          <h3 style={{ color: "#ffffff", fontSize: "18px", fontWeight: "600", marginBottom: "16px" }}>
            Top Performing Quizzes
          </h3>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {loading ? (
              <div style={{ color: "rgba(255, 255, 255, 0.7)", textAlign: "center", padding: "20px" }}>
                Loading top quizzes...
              </div>
            ) : (
              data?.top_quizzes.map((quiz: any, index: number) => (
                <div
                  key={quiz.quiz_id}
                  style={{
                    background: "rgba(255, 255, 255, 0.08)",
                    borderRadius: "12px",
                    padding: "20px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      background: `linear-gradient(135deg, ${index === 0 ? '#fbbf24' : '#f59e0b'}, ${index === 0 ? '#f59e0b' : '#d97706'})`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#ffffff",
                      fontSize: "18px",
                      fontWeight: "700",
                      flexShrink: 0,
                    }}
                  >
                    {index + 1}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        color: "#ffffff",
                        fontSize: "16px",
                        fontWeight: "600",
                        marginBottom: "4px",
                        lineHeight: "1.3",
                      }}
                    >
                      {quiz.question || `${quiz.quiz_id}`}
                    </div>
                    {/* <div
                      style={{
                        color: "rgba(255, 255, 255, 0.6)",
                        fontSize: "12px",
                      }}
                    >
                      Quiz ID: {quiz.quiz_id}
                    </div> */}
                  </div>
                  <div
                    style={{
                      textAlign: "right",
                      flexShrink: 0,
                    }}
                  >
                    <div
                      style={{
                        color: "#fbbf24",
                        fontSize: "24px",
                        fontWeight: "700",
                        lineHeight: "1",
                      }}
                    >
                      {quiz.answers}
                    </div>
                    <div
                      style={{
                        color: "rgba(255, 255, 255, 0.6)",
                        fontSize: "12px",
                        marginTop: "2px",
                      }}
                    >
                      answers
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Summary Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
          <div
            style={{
              background: "rgba(255, 255, 255, 0.08)",
              borderRadius: "12px",
              padding: "20px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              textAlign: "center",
            }}
          >
            <div style={{ color: "#fbbf24", fontSize: "28px", fontWeight: "700", marginBottom: "4px" }}>
              {data?.total_answered.toLocaleString() || 0}
            </div>
            <div style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px" }}>Total Answers</div>
          </div>
          <div
            style={{
              background: "rgba(255, 255, 255, 0.08)",
              borderRadius: "12px",
              padding: "20px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              textAlign: "center",
            }}
          >
            <div style={{ color: "#fbbf24", fontSize: "28px", fontWeight: "700", marginBottom: "4px" }}>
              {data?.total_shown.toLocaleString() || 0}
            </div>
            <div style={{ color: "rgba(255, 255, 255, 0.7)", fontSize: "14px" }}>Total Quizzes Displayed</div>
          </div>
        </div>
      </div>
    </div>
  );
};